import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../_service/auth.service';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: 'header.component.html',
    styleUrls: [
        './header.component.css',
    ]
})

export class HeaderComponent implements OnInit, OnDestroy {
    public toggle: boolean = false;
    public _subcription: Subscription;
    public username: string;

    constructor(private  _authService: AuthService) {
    }

    ngOnInit() {
        this.username = localStorage.getItem('username');
    }

    logOut() {
        this._subcription = this._authService.logout().subscribe(data => {
            // console.log(data);
            location.reload();
        });
        localStorage.removeItem('currentUser');

    }

    openPopup() {
        this.toggle = !this.toggle;
    }

    ngOnDestroy() {
        if (this._subcription) {
            this._subcription.unsubscribe();
        }
    }
}
